export const deviceSize = {
  mobileSmall: '360px',
  mobile: '600px',
  splitScreenNarrow: '900px',
  splitScreen: '1000px',
  laptopM: '1280px',
  laptopL: '1440px',
  fullHD: '1920px'
};

export const deviceSizeNumber = {
  mobileSmall: 360,
  mobile: 600,
  splitScreenNarrow: 900,
  splitScreen: 1000,
  laptopM: 1280,
  laptopL: 1440,
  fullHD: 1920
};

export const windowMinWidth = {
  mobileSmall: `(min-width: ${deviceSize.mobileSmall})`,
  mobile: `(min-width: ${deviceSize.mobile})`,
  splitScreenNarrow: `(min-width: ${deviceSize.splitScreenNarrow})`,
  splitScreen: `(min-width: ${deviceSize.splitScreen})`,
  laptopM: `(min-width: ${deviceSize.laptopM})`,
  laptopL: `(min-width: ${deviceSize.laptopL})`,
  fullHD: `(min-width: ${deviceSize.fullHD})`
};

export const windowMaxWidth = {
  mobileSmall: `(max-width: ${deviceSize.mobileSmall})`,
  mobile: `(max-width: ${deviceSize.mobile})`,
  splitScreenNarrow: `(max-width: ${deviceSize.splitScreenNarrow})`,
  splitScreen: `(max-width: ${deviceSize.splitScreen})`,
  laptopM: `(max-width: ${deviceSize.laptopM})`,
  laptopL: `(max-width: ${deviceSize.laptopL})`,
  fullHD: `(max-width: ${deviceSize.fullHD})`
};
